import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

const CandidateDetails = ({ interview, candidate, onUpdateStatus, onClose }) => {
    const { roles } = useContext(AuthContext);
    const isHR = roles.includes("HR");
    const [activeTab, setActiveTab] = useState("details");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [feedback, setFeedback] = useState("");
    const [feedbackError, setFeedbackError] = useState("");

    const statusColors = {
        Selected: "bg-emerald-100 text-emerald-800",
        Rejected: "bg-red-100 text-red-800",
        Hold: "bg-amber-100 text-amber-800",
        default: "bg-gray-100 text-gray-800"
    };
      
    // // console.log("onUpdateStatus: ", onUpdateStatus);

    const handleOpenModal = (status) => {
        setSelectedStatus(status);
        setIsModalOpen(true);
    };

    const handleSubmitFeedback = () => {
      if (!feedback.trim()) {
          setFeedbackError("Feedback is required.");
          setIsModalOpen(true);
          return;
      }

      setFeedbackError(""); 

      const feedbackWithStatus = {
          status: selectedStatus,
          overallFeedback: feedback,
      };

      // console.log("feedback status: ", feedbackWithStatus)

      if (onUpdateStatus) {
          // console.log("true")
          onUpdateStatus(feedbackWithStatus);
      } else {
          // console.log("false")
      }

      setFeedback("");
      setIsModalOpen(false);
    };

    const handleJoinMeeting = (interview) => {
        try {
            const meetingLink = interview?.interview_link?.trim();
            if (meetingLink) {
                if (meetingLink.startsWith("http") || meetingLink.startsWith("https")) {
                    // Create a temporary link element to open in new tab
                    const link = document.createElement('a');
                    link.href = meetingLink;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    alert("Invalid meeting link format. Please check the link.");
                }
            } else {
                alert("Meeting link is not available for this interview.");
            }
        } catch (error) {
            console.error("Error while opening the meeting link:", error);
            alert("An error occurred while trying to join the meeting. Please try again.");
        }
    };

    const getStatusClass = (status) => {
        return statusColors[status] || statusColors.default;
    };

    const renderTabContent = () => {
        switch (activeTab) {
          case "details":
            return (
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                    <h4 className="text-gray-500 text-sm font-medium mb-1">Email</h4>
                    <p className="text-gray-900 font-medium">{candidate.email}</p>
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                    <h4 className="text-gray-500 text-sm font-medium mb-1">Campaign Name</h4>
                    <p className="text-gray-900 font-medium">{candidate.campaign_name	}</p>
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                    <h4 className="text-gray-500 text-sm font-medium mb-1">Created At</h4>
                    <p className="text-gray-900 font-medium">
                      {new Date(candidate.created_at).toLocaleString()}
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                    <h4 className="text-gray-500 text-sm font-medium mb-1">Updated At</h4>
                    <p className="text-gray-900 font-medium">
                      {new Date(candidate.updated_at).toLocaleString()}
                    </p>
                  </div>
                </div>
                {/* Join Meeting Button */}
                {(candidate.status === "Shortlisted" || candidate.status === "Hold") && (
                  <div className="pt-2">
                    {interview?.interview_link?.trim() ? (
                      <button
                        onClick={() => handleJoinMeeting(interview)}
                        className="flex items-center gap-2 px-5 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-all shadow-md hover:shadow-lg focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm12.5 1.5a1.5 1.5 0 00-3 0v5a1.5 1.5 0 003 0v-5z" />
                        </svg>
                        Join Interview Meeting
                      </button>
                    ) : (
                      <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                        <h4 className="text-gray-500 text-sm font-medium mb-1">Interview Location</h4>
                        <p className="text-gray-900 font-medium">
                          {interview?.location || "No location specified"}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          case "resume":
            return candidate.resume_path ? (
              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                <h4 className="text-gray-500 text-sm font-medium mb-3">Resume</h4>
                <a
                  href={interview.resume_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 text-indigo-600 rounded-lg hover:bg-gray-50 transition-all focus:ring-2 focus:ring-indigo-200 inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    // Create a temporary link element to open in new tab
                    const link = document.createElement('a');
                    link.href = interview.resume_url;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                  </svg>
                  View Resume
                </a>
              </div>
            ) : (
              <div className="bg-gray-50 rounded-xl p-8 flex flex-col items-center justify-center text-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-gray-400 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p className="text-gray-500 font-medium">No resume uploaded for this candidate.</p>
              </div>
            );
          default:
            return null;
        }
    };

    return (
      <div className="bg-gray-50 p-6 rounded-2xl">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between md:items-center gap-6 mb-8">
          <div className="flex items-center justify-between gap-4">
            <div className="flex gap-2 items-center">
              <div className="h-16 w-16 rounded-full bg-gradient-to-r from-indigo-600 to-blue-400 flex items-center justify-center text-2xl font-bold text-white shadow-md">
                {candidate.name.charAt(0).toUpperCase()}
              </div>
              
              <div>
                <h3 className="text-2xl font-semibold text-gray-900">{candidate.name}</h3>
                <span className={`inline-flex items-center px-3 py-1 text-sm font-medium rounded-full mt-1 ${getStatusClass(candidate.status)}`}>
                  {candidate.status}
                </span>
              </div>
            </div>

            <button
              onClick={onClose}
              className="block md:hidden lg:hidden text-gray-500 dark:hover:text-gray-400 hover:text-gray-800 text-xl m-2">
              ✖
            </button>
          </div>
          <div className="flex items-center gap-4">
            {isHR && (candidate.status === "Shortlisted" || candidate.status === "Hold") && (
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => handleOpenModal("Selected")}
                  className="md:px-5 md:py-2 md:text-md text-sm px-3 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-all shadow-sm font-medium focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
                >
                  Approve
                </button>
                <button
                  onClick={() => handleOpenModal("Rejected")}
                  className="md:px-5 md:py-2 md:text-md text-sm px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all shadow-sm font-medium focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  Reject
                </button>
                {candidate.status === "Shortlisted" && ( 
                <button
                  onClick={() => handleOpenModal("Hold")}
                  className="md:px-5 md:py-2 md:text-md text-sm px-3 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-all shadow-sm font-medium focus:ring-2 focus:ring-amber-400 focus:ring-offset-2">
                  Hold
                </button>
                )}
              </div>
            )}
            <button
              onClick={onClose}
              className="hidden md:block lg:block text-gray-500 dark:hover:text-gray-400 hover:text-gray-800 text-xl m-2">
              ✖
            </button>
          </div>
        </div>
  
        {/* Tabs */}
        <div className="mb-6 flex space-x-1 bg-gray-100 p-1 rounded-lg w-fit">
          {["details", "resume"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                activeTab === tab
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-600 hover:text-gray-900 hover:bg-white/50"
              }`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>
  
        {/* Tab Content */}
        <div>{renderTabContent()}</div>
  
        {/* Feedback Modal */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop-blur-sm">
            <div 
              className="bg-white w-full h-full md:rounded-none rounded-xl shadow-xl "
              onClick={(e) => e.stopPropagation()}
            >
              <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <div className={`w-3 h-3 rounded-full ${
                    selectedStatus === "Selected" ? "bg-emerald-500" :
                    selectedStatus === "Rejected" ? "bg-red-500" : "bg-amber-500"
                  }`}></div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    Provide Feedback ({selectedStatus})
                  </h3>
                </div>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="text-gray-400 hover:text-gray-600 focus:outline-none h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100">
                  &times;
                </button>

              </div>
              <div className="px-6 py-5">
                <textarea
                  rows="6"
                  value={feedback}
                  required
                  onChange={(e) => setFeedback(e.target.value)}
                  placeholder="Write detailed feedback about this candidate..."
                  className="w-full border border-gray-200 rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                ></textarea>
                  {feedbackError && (
                  <p className="text-red-500 text-sm mt-1">{feedbackError}</p>
                  )}
              </div>
              <div className="px-6 py-4 border-t border-gray-100 flex justify-between items-center gap-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 bg-white border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmitFeedback}
                  className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-medium shadow-sm"
                >
                  Submit Feedback
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
};

export default CandidateDetails;
